import Vue from "vue";
import Router from "vue-router";
import IndexPage from "@/view/index";
import newsPage from "@/view/news";
import sciencePage from "@/view/science";
import solutionPage from "@/view/solution";
import coursePage from "@/view/course";
import matchPage from "@/view/match";
import projectPage from "@/view/project";
import cooperatePage from "@/view/cooperate";
import meansPage from "@/view/means";
import aboutPage from "@/view/th_about";
import vedioPage from "@/view/th_vedio";
import detailPage from "@/view/th_detail";

Vue.use(Router);

export default new Router({
  routes: [
    ////////////网站前端页面/////////////////////
    {
      path: "/",
      name: "indexPage",
      component: IndexPage
    },
    {
      path: "/News",
      name: "newPage",
      component: newsPage
    },
    {
      path: "/Science",
      name: "sciencePage",
      component: sciencePage
    },
    {
      path: "/Solution",
      name: "solutionPage",
      component: solutionPage
    },
    {
      path: "/Course",
      name: "coursePage",
      component: coursePage
    },
    {
      path: "/Match",
      name: "matchPage",
      component: matchPage
    },
    {
      path: "/about",
      name: "aboutPage",
      component: aboutPage
    },
    {
      path: "/project",
      name: "projectPage",
      component: projectPage
    },
    {
      path: "/cooperate",
      name: "cooperatePage",
      component: cooperatePage
    },
    {
      path: "/Means",
      name: "meansPage",
      component: meansPage
    },
    {
      path: "/video",
      component: vedioPage,
      beforeEnter(to, from, next) {
        window.location.href =
          "https://space.bilibili.com/626211996?spm_id_from=333.1007.0.0";
      }
    },
    ////////////二级页面//////////////////////
    {
      path: "/secth/about",
      name: "aboutPage",
      component: aboutPage
    },
    {
      path: "/secth/vedio",
      name: "vedioPage",
      component: vedioPage
    },
    {
      path: "/secth/detail",
      name: "detailPage",
      component: detailPage
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js